import React from 'react'
import LoadingBar from 'react-top-loading-bar'

const PageLoader = () => (
  <LoadingBar progress={100} height={3} color="#ee532f" />
)

export default PageLoader
